import React from 'react';
import { format } from 'date-fns';
import { Stack } from '@cp/ds/src/components/stack';
import { mergeSx } from '@cp/ds/src/utils/sx/merge';
import { MOBILE_BREAKPOINT_THRESHOLD } from '@cp/ds/src/theme';
import { Typography } from '@cp/ds/src/components/typography';
import { ClientType } from '@common/model/client/clientType';
import { DateFormat } from '@common/const/date';
import { useIsMobile } from '@cp/ds/src/hooks';
import { PersonalInformationProps } from './model';
import { NotFilled } from './notFilled';
import { NameAndSurname } from './nameAndSurname';
import { ClientLocation } from './clientLocation';

export * from './model';
export * from './nameAndSurname';
export * from './clientLocation';

export const PersonalInformation: React.FC<PersonalInformationProps> = ({
  clientProfile,
  disableTopRow,
  topRightContent,
  showEmail,
  sx,
}) => {
  const isMobile = useIsMobile();

  if (!clientProfile) {
    return null;
  }

  return (
    <Stack
      alignItems="flex-start"
      direction="column"
      gap={isMobile ? 0.5 : 1.5}
      sx={mergeSx(
        {
          overflow: 'hidden',
        },
        sx,
      )}
    >
      {!disableTopRow && (
        <Stack direction="row" sx={{ alignItems: 'center', justifyContent: 'space-between', alignSelf: 'stretch' }}>
          <NameAndSurname clientProfile={clientProfile} />

          {topRightContent}
        </Stack>
      )}

      {clientProfile.type === ClientType.Specialist && (
        <Typography>
          <Typography sx={{ color: { xs: 'gray dark', [MOBILE_BREAKPOINT_THRESHOLD]: 'gray' } }}>Дата рождения:</Typography>{' '}
          {clientProfile.birthDate ? (
            format(new Date(clientProfile.birthDate), DateFormat.DateDefault)
          ) : (
            <NotFilled>дата рождения не указана</NotFilled>
          )}
        </Typography>
      )}

      {showEmail && clientProfile.email ? (
        <Typography>{clientProfile.email}</Typography>
      ) : (
        <Typography sx={{ color: 'brand pink' }}>email не указан</Typography>
      )}

      <Typography>{clientProfile.phone || <NotFilled>Укажите номер телефона</NotFilled>}</Typography>

      <ClientLocation clientProfile={clientProfile} />
    </Stack>
  );
};
